export const PROBLEM_SET_TAG = 'ProblemSet'
export const ASSIGNMENT_TAG = 'Assignment'
export const SHARED_ASSIGNMENT_TAG = 'SharedAssignment'
export const COMPONENT_TAG = 'Component'
export const GROUP_TAG = 'Group'
export const QUESTION_TAG = 'Question'
export const PROMPT_TAG = 'Prompt'
export const CATEGORY_TAG = 'Category'
export const CATALOG_ITEM_TAG = 'CatalogItem'
export const PATTERN_TAG = 'Pattern'
export const VERSION_TAG = 'Version'
export const SHARE_SUGGESTION_TAG = 'ShareSuggestion'
export const SUBMISSION_TAG = 'Submission'
export const ESCALATED_ANSWER_TAG = 'EscalatedAnswer'
export const ANSWER_CATEGORY_TAG = 'AnswerCategory'
export const APPROVE_ANALYTICS_TAG = 'ApproveAnalytics'
export const LMS_QUESTIONS_TAG = 'LmsQuestions'
export const COT_TAG = 'Cot'
export const DISCIPLINE_TAG = 'Discipline'
export const USER_TAG = 'User'
export const CRITERIA_FILTER_TAG = 'CriteriaFilter'
export const CONCEPTUAL_LABEL_TAG = 'ConceptualLabel'
export const CONCEPTUAL_LABEL_TYPE_TAG = 'ConceptualLabelType'
export const OVERRULE_REASONING_TAG = 'OverruleReasoning'
export const ORGANIZATION_TAG = 'Organization'
export const ATTACHMENT_TAG = 'Attachment'
export const createTagsForList = (list, type, identifier = 'id') => [
    ...(list || []).map(item => ({ type, id: item[identifier] })),
    { type, id: 'LIST' },
]
